<template>
  <div id="duplicate">
    <CRow>
      <CCol xs="12" sm="6" md="6" lg="6" xl="2" v-if="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_PROVINCE') || $hasAuthor('ROLE_MANAGEMENT')">
        <BaseSelect :options="districtCodeInput.options" :data="districtCodeInput.data" ref="districtCodeInput">
        </BaseSelect>
      </CCol>
      <CCol xs="12" sm="6" md="6" lg="6" xl="2" v-if="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_PROVINCE') || $hasAuthor('ROLE_MANAGEMENT') || $hasAuthor('ROLE_DISTRICT')">
        <BaseSelect :options="wardCodeInput.options" :data="wardCodeInput.data" ref="wardCodeInput"></BaseSelect>
      </CCol>
      <CCol>
        <div class="form-group">
          <label style="color: white"></label>
          <div style="margin-top: 10px">
            <CButton style="float: right; margin-left: 5px" color="primary" v-c-tooltip.hover="'Tải lại'"
              class="btn-action-primary" @click="loadData()">
              <i class="fa fa-refresh"></i>&nbsp;Tải lại
            </CButton>
          </div>
        </div>
      </CCol>
    </CRow>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <table class="table">
          <thead>
            <tr>
              <!-- <td>#</td> -->
              <!-- <th>Ngày tạo</th> -->
              <th>Ngày phát</th>
              <th>Các khung giờ trùng</th>
              <th>Địa bàn</th>
              <th>Thao tác</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="items.length > 0">
              <tr v-for="item in items">
                <!-- <td>{{ item.index }}</td> -->
                <!-- <td>{{ $helper.formatDate(item.createDate) }}</td> -->
                <td>{{ $helper.formatDateDDMMYYYY(item.playDate) }}</td>
                <td>
                  <span class="badge badge-light mr-2" v-for="time in item.times">
                    {{ time }}
                  </span>
                </td>
                <td>{{ item.locationName }}</td>
                <td class="action-btn-group">
                  <div class="action-btn-wrapper">
                    <CButton color="info" variant="outline" v-c-tooltip.hover="'Xem chi tiết'" square size="sm"
                      @click="viewDetail(item)">
                      <i class="fa fa-eye"></i>
                    </CButton>
                  </div>
                </td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td colspan="4">
                  <span style="color: #969696">Danh sách trống!</span>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
        <div v-if="items.length > 0">
          <div style="display:flex; flex-wrap:wrap;">
            <div style="font-size:.95em;color:gray; padding-left:.75rem;">
              {{ items.length > 0 ? 1 : 0 }}-{{ items.length }} /
              {{ items.length }} bản ghi
            </div>
          </div>
        </div>
      </CCardBody>
    </CCard>

    <CModal size="xl" title="Thông tin chi tiêt lịch trùng" :show.sync="isShowModal" :closeOnBackdrop="false">
      <CRow>
        <!-- <table class="table">
          <thead>
            <tr>
              <th>#</th>
              <th>Ngày tạo</th>
              <th>Ngày phát</th>
              <th>Thời điểm bắt đầu</th>
              <th>Thời điểm kết thúc</th>
              <th>Trạng thái</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in itemsDetail">
              <td class="group-checkbox">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" :value="item.id" :id="item.id"
                    v-c-tooltip.hover="'Selected'" />
                  <label class="custom-control-label" :for="item.id"></label>
                </div>
              </td>
              <td>{{ $helper.formatDate(item.createDate) }}</td>
              <td>{{ $helper.formatDateDDMMYYYY(item.playDate) }}</td>
              <td>{{ $helper.formatHHMM(item.startTime) }}</td>
              <td>{{ $helper.formatHHMM(item.endTime) }}</td>
              <td>
                <span v-if="item.status == ScheduleDetailStatus.PENDING" class="badge badge-info">Chờ phát</span>
                <span v-else-if="item.status == ScheduleDetailStatus.PLAYING" class="badge badge-warning">Đang
                  phát</span>
                <span v-else-if="item.status == ScheduleDetailStatus.BROADCAST" class="badge badge-success">Đã
                  phát</span>
                <span v-else-if="item.status == ScheduleDetailStatus.ERROR" class="badge badge-danger">Phát lỗi</span>
                <span v-else-if="item.status == ScheduleDetailStatus.CANCEL" class="badge badge-danger">Đã hủy</span>
                <span v-else-if="item.status == ScheduleDetailStatus.COINCIDENT" class="badge badge-danger">Bị
                  trùng</span>
              </td>
            </tr>
          </tbody>
        </table> -->
        <CDataTable class="custom-scroll" :items="mainTable.items" :fields="mainTable.options.fields" :sorter="true"
          :loading="loading.value" :clickableRows="true" @row-clicked="rowClickTable" :hover="true">
          <template #index="{ index, item }">
            <td class="action-btn-group">
              <CInputRadio type="radio" addInputClasses="override-custom" custom :value="item.id" name="itemSelected"
                :checked="item.isSelected" />
            </td>
          </template>
          <template #createDate="{ item }">
            <td v-if="item.createDate != null">
              {{ $helper.formatDate(item.createDate) }}
            </td>
            <td v-else></td>
          </template>
          <template #playDate="{ item }">
            <td>
              {{ $helper.formatDateDDMMYYYY(item.playDate) }}
            </td>
          </template>
          <template #startTime="{ item }">
            <td>
              {{ $helper.formatHHMM(item.startTime) }}
            </td>
          </template>
          <template #endTime="{ item }">
            <td>{{ $helper.formatHHMM(item.endTime) }}</td>
          </template>
          <template #status="{ item }">
            <td>
              <span v-if="item.status == ScheduleDetailStatus.PENDING" class="badge badge-info">Chờ phát</span>
              <span v-else-if="item.status == ScheduleDetailStatus.PLAYING" class="badge badge-warning">Đang
                phát</span>
              <span v-else-if="item.status == ScheduleDetailStatus.BROADCAST" class="badge badge-success">Đã
                phát</span>
              <span v-else-if="item.status == ScheduleDetailStatus.ERROR" class="badge badge-danger">Phát lỗi</span>
              <span v-else-if="item.status == ScheduleDetailStatus.CANCEL" class="badge badge-danger">Đã hủy</span>
              <span v-else-if="item.status == ScheduleDetailStatus.COINCIDENT" class="badge badge-danger">Bị
                trùng</span>
            </td>
          </template>
          <template #url="{ item }">
            <td>
              <span class="view-file" @click="viewFile(item.fileName, item.url, null)">Ấn vào để xem tệp</span>
            </td>
          </template>
          <template slot="no-items-view">
            <span style="color: #969696">Danh sách trống!</span>
          </template>
          <template slot="loading">
            <BaseFormLoading :loading="true"></BaseFormLoading>
          </template>
        </CDataTable>
      </CRow>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="isShowModal = false"><i class="fa fa-times"></i> Hủy bỏ
        </button>
        <button type="button" class="btn btn-primary" :disabled="itemChoose == null" @click="submitData()"><i
            class="fa fa-check"></i>
          Lưu lại
        </button>
      </template>
      <BaseFormLoading :loading="loadingDetail.value"></BaseFormLoading>
    </CModal>
    <BaseFormLoading :loading="loading.value"></BaseFormLoading>

    <BaseFormPreview v-if="previewModel.isShowModal" :title="previewModel.title" :url="previewModel.url"
      :play-list-id="previewModel.playListId" @close-modal="previewModel.isShowModal = false"></BaseFormPreview>
  </div>
</template>

<script>
import BaseTable from "@/views/base/BaseDataTable";
import ModalConfirm from "@/views/base/BaseModalConfirm";
import BaseFormLoading from "@/views/base/BaseFormLoading";
import { DatePicker } from "v-calendar";
import BaseSwitch from "@/views/base/BaseSwitch";
import BaseSelect from "@/views/base/BaseSelect2";
import BaseModal from "@/views/base/BaseModal";
import { ScheduleDetailStatus } from "../../constant";
import BaseFormPreview from "@/views/base/BaseFormPreview";

export default {
  name: "ListDuplicate",
  components: {
    BaseModal,
    BaseSelect,
    BaseFormLoading,
    BaseTable,
    DatePicker,
    ModalConfirm,
    BaseSwitch,
    BaseFormPreview
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
    },
    showWarningMsg: {
      type: "warn",
      title: "warn",
    },
  },
  data() {
    let that = this;

    return {
      ScheduleDetailStatus: ScheduleDetailStatus,
      loading: { value: false },
      loadingDetail: { value: false },
      items: [],
      itemChoose: null,
      // itemsDetail: [],
      previewModel: {
        isShowModal: false,
        title: '',
        url: '',
        playListId: ''
      },
      isShowModal: false,
      labelIcon: {
        labelOn: '\u2713',
        labelOff: '\u2715'
      },
      districtCodeInput: {
        options: {
          filter: true,
          label: "Quận/Huyện",
          selectAllText: "Tất cả Quận/Huyện",
          'keyField': 'key',
          'valueField': 'value',
          lazyLoad: (this.$hasAuthor('ROLE_ADMIN') || this.$hasAuthor('ROLE_PROVINCE') || this.$hasAuthor('ROLE_MANAGEMENT')) ? false : true
        },
        data: {
          name: "districtCode",
          items: [],
          model: null,
          source: {
            url: '/common/findByParentCodeAndCode',
            dataSubmit: function () {
              return {
                level: 1
              }
            },
            response: function (dataResponse) {
              that.districtCodeInput.data.items = dataResponse.data;
            }
          },
        }
      },
      wardCodeInput: {
        options: {
          filter: true,
          label: "Phường/Xã",
          selectAllText: "Tất cả Phường/Xã",
          'keyField': 'key',
          'valueField': 'value',
          lazyLoad: this.$hasAuthor('ROLE_DISTRICT') ? false : true,
          // disabled: this.$hasAuthor('ROLE_DISTRICT') ? false : true
        },
        data: {
          name: "wardCode",
          model: null,
          items: [],
          source: {
            url: '/common/findByParentCodeAndCode',
            dataSubmit: function () {
              return {
                parentCode: that.districtCodeInput.data.model,
                level: 2
              }
            },
            response: function (dataResponse) {
              that.wardCodeInput.data.items = dataResponse.data;
            },
          },
        }
      },
      mainTable: {
        options: {
          fields: [
            { key: "index", label: "#", sorter: false, filter: false },
            { key: "createDate", label: "Ngày tạo" },
            { key: "playDate", label: "Ngày phát" },
            { key: "startTime", label: "Thời điểm bắt đầu" },
            { key: "endTime", label: "Thời điểm kết thúc" },
            { key: "status", label: "Trạng thái" },
            { key: "fileName", label: "Tiêu đề bản tin" },
            { key: "url", label: "Bản tin" },
          ],
          slots: [
            "index", "createDate", "playDate", "startTime", "endTime", "status", "url"
          ],
          sorter: true,
          columnFilter: false,
        },
        items: [],
      },
      locationCode: {
        data: {
          name: 'locationCode',
          model: ''
        }
      },
    };
  },
  methods: {
    // async viewFile(url) {
    //   window.open(this.$helper.viewFileByUrl(url))
    // },
    async viewFile(title, url, playListId) {
      this.previewModel.url = url;
      this.previewModel.title = title;
      this.previewModel.playListId = playListId;
      this.previewModel.isShowModal = true;
    },
    loadData() {
      let that = this;
      that.loading.value = true;
      this.$helper.loadDataSource({
        url: "/schedule-detail/get-list-duplicate",
        dataSubmit: function () {
          return { locationCode: that.locationCode.data.model }
        },
        ignoreDefaultData: true,
        // isJsonContentType: false,
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            that.items = response.data.data.dataContent.content;
            that.loading.value = false;
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        },
      });
    },
    viewDetail(item) {
      let that = this;
      that.isShowModal = true;
      that.loadingDetail.value = true;
      if (that.mainTable.items != null && that.mainTable.items.length > 0) {
        that.mainTable.items = [];
      }
      that.$helper.loadDataSource({
        url: "/schedule-detail/get-duplicate-detail",
        dataSubmit: function () {
          return { times: item.times, playDate: item.playDate, locationCode: item.locationCode }
        },
        ignoreDefaultData: true,
        // isJsonContentType: false,
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            // that.itemsDetail = response.data.data.dataContent.content;
            let _data = response.data.data;
            _data.dataContent.content.map((each) => {
              if (that.itemChoose != null && that.itemChoose != ''
                && that.itemChoose.id && each.id == that.itemChoose.id) {
                each.isSelected = true;
              } else {
                each.isSelected = false;
              }
              that.mainTable.items.push(each);
            });
            that.loadingDetail.value = false;
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        },
      });
    },
    submitData() {
      let that = this;
      that.loadingDetail.value = true;
      that.$helper.loadDataSource({
        url: "/schedule-detail/update-duplicate-detail",
        dataSubmit: function () {
          return { items: that.mainTable.items, itemChoose: that.itemChoose }
        },
        ignoreDefaultData: true,
        // isJsonContentType: false,
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            that.isShowModal = false;
            that.loadingDetail.value = false;
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        },
      });
    },
    rowClickTable(...args) {
      let that = this;
      console.log(args)
      that.mainTable.items.map((item, index) => {
        if (item.id === args[0].id) {
          item.isSelected = true;
          that.itemChoose = item;
        } else {
          item.isSelected = false;
        }
      });
    },
  },
  created: function () {
  },
  mounted() {
    // this.loadData();
  },
  watch: {
    'districtCodeInput.data.model': function (value) {
      // console.log(value)
      if (value) {
        // this.$refs.wardCodeInput.loadData();
        this.locationCode.data.model = value;
        // this.wardCodeInput.options.disabled = false;
        // this.loadData();
      } else {
        // this.wardCodeInput.data.items = [];
        // this.wardCodeInput.options.disabled = true;
      }
      this.$refs.wardCodeInput.loadData();
      this.wardCodeInput.data.model = null
    },
    'wardCodeInput.data.model': function (value) {
      // console.log(value)
      if (value) {
        this.locationCode.data.model = value;
      } else {
        this.locationCode.data.model = this.districtCodeInput.data.model;
      }
      this.loadData();
    },
  },
  computed: {},
};
</script>
<style scoped>
.td-roles {
  max-width: 250px;
}
</style>

<style>
#duplicate .override-custom {
  opacity: 0 !important;
}
</style>
